import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { t } = useTranslation('home');

  return (
    <section className="py-14 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left Text Content */}
          <div className="flex-1">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-label uppercase tracking-wider mb-6">
              {t('about_label')}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-8 leading-tight">
              {t('about_title_1')}
              <br />
              {t('about_title_2')}
              <br />
              {t('about_title_3')}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-5 font-body">
              {t('about_desc_1')}
            </p>
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-8 font-body">
              {t('about_desc_2')}
            </p>
            <Link
              to="/czym-jest-kakobuy-spreadsheet"
              className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 font-label font-medium text-sm whitespace-nowrap transition-colors duration-200 group"
            >
              {t('btn_learn_more')}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
            </Link>
          </div>

          {/* Right Card */}
          <div className="flex-1 w-full">
            <div className="relative bg-accent-500 rounded-3xl p-8 md:p-10 overflow-hidden">
              {/* Decorative dots */}
              <div className="absolute top-6 right-6 flex gap-1.5">
                <span className="w-2 h-2 rounded-full bg-background-50/30"></span>
                <span className="w-2 h-2 rounded-full bg-background-50/40"></span>
                <span className="w-2 h-2 rounded-full bg-background-50/30"></span>
              </div>

              <p className="text-xs text-background-50/60 font-label uppercase tracking-wider mb-6">Misja</p>

              <blockquote className="text-background-50 text-lg md:text-xl leading-relaxed mb-8 font-heading italic">
                Naszą misją jest dostarczanie najbardziej aktualnych i sprawdzonych arkuszy produktowych Kakobuy dla polskich użytkowników, oszczędzając Twój czas i pieniądze.
              </blockquote>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-background-50/15 flex items-center justify-center overflow-hidden flex-shrink-0">
                  <span className="text-background-50 font-heading font-bold text-lg">KS</span>
                </div>
                <div>
                  <p className="text-background-50 font-label font-semibold text-sm">Kakobuy Spreadsheet</p>
                  <p className="text-background-50/60 text-xs font-body">Zespół redakcyjny</p>
                </div>
                <Link
                  to="/czym-jest-kakobuy-spreadsheet"
                  className="ml-auto w-9 h-9 rounded-full bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-background-50 text-sm"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}